import { Component, Injector, Input, OnInit } from '@angular/core';
import { finalize } from 'rxjs';
import { AppComponentBase } from '@shared/app-component-base';
import { HistoricoCandidatoVagaDto, HistoricoCandidatoVagaServiceProxy } from '@shared/service-proxies/service-proxies';

@Component({
  selector: 'historico-candidato-vaga',
  templateUrl: './historico-candidato-vaga.component.html',
  styleUrls: ['./historico-candidato-vaga.component.scss']
})
export class HistoricoCandidatoVagaComponent extends AppComponentBase implements OnInit {

  @Input() candidatoVagaId: string;
  public historico: HistoricoCandidatoVagaDto[] = [];
  constructor(
    injector: Injector,
    private readonly _historicoCandidatoVagaService: HistoricoCandidatoVagaServiceProxy
  ){ 
      super(injector)
    }

  ngOnInit(): void {
    this.getHistorico();
  }

  protected getHistorico(){
    abp.ui.setBusy();
    this._historicoCandidatoVagaService.getHistorico(this.candidatoVagaId).pipe(
      finalize(() => {
        abp.ui.clearBusy();
      })
    ).subscribe((resp) => {
      this.historico = resp;
    })
  }
}
